import React from 'react';

import { Typography, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    marginTop: '6.5rem',
    [theme.breakpoints.down('sm')]: {
      marginTop: '2.5rem'
    }
  },
  textBox: {
    width: '65%',
    padding: '2.75rem 5.125rem ',
    borderTop: '1px black solid',
    borderBottom: '1px black solid',
    [theme.breakpoints.down('sm')]: {
      width: '86%',
      padding: '2rem 0'
    }
  },
  pg1: {
    marginTop: '1.5rem',
    [theme.breakpoints.down('sm')]: {
      marginTop: '1rem'
    }
  },
  bolded: {
    ...theme.typography.body2,
    [theme.breakpoints.down('sm')]: {
      fontSize: '16px',
      lineHeight: '28px'
    }
  },
  mobileH3: {
    [theme.breakpoints.down('sm')]: {
      fontSize: '18px',
      lineHeight: '18px'
    }
  },
  mobileBody1: {
    [theme.breakpoints.down('sm')]: {
      fontSize: '16px',
      lineHeight: '28px',
      letterSpacing: '.5px'
    }
  }
}));

const Overwhelmed = () => {
  const classes = useStyles();
  return (
    <Grid container direction="column" alignItems="center" className={classes.wrapper}>
      <Grid container direction="column" className={classes.textBox}>
        <Grid item>
          <Typography variant="h3" className={classes.mobileH3}>
            OVERWHELMED
          </Typography>
        </Grid>
        <Grid item className={classes.pg1}>
          <Typography variant="body1" className={classes.mobileBody1}>
            Pat Gill was overwhelmed. She knew her Medicare Advantage plan offered a variety of
            health care benefits, but she didn’t know where to start. Pat is not alone: for many
            older adults, navigating the health care system can be a challenge.
          </Typography>
        </Grid>
        <Grid item className={classes.pg1}>
          <Typography variant="body1" className={classes.mobileBody1}>
            <span className={classes.bolded}>PAT:</span> I had given up. Basically, I was frozen in
            place. I had to really confront the fact that I'm getting older, and I don't know about
            all the benefits that are available to me. I knew that I had to get things done, but I
            needed somebody who was empathetic, who could actually help me sort it all out.
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Overwhelmed;
